module.exports = __webpack_public_path__ + "img/newBanner.abe692c8.jpg";